(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["filters-toggle"] && !Shopify.designMode) return;
  try {
    (function() {
    const toggleButton = document.querySelector('[data-filter-toggle-text]');
    const toggleLabel = document.querySelector('[data-filter-toggle-label]');
    
    if (!toggleButton || !toggleLabel) return;
    
    // Find the filters drawer - the button uses on:click="#filters-drawer/showDialog"
    const findFiltersDrawer = () => {
      // Try finding by id first (most likely a custom element component)
      let drawer = document.getElementById('filters-drawer');
      
      // If not found, look for dialog-component or dialog element that contains facets--drawer
      if (!drawer) {
        // Try finding by class that might have the drawer
        const facetsDrawer = document.querySelector('.facets--drawer');
        if (facetsDrawer) {
          drawer = facetsDrawer.closest('dialog-component') ||
                   facetsDrawer.closest('[id*="filters"]') ||
                   facetsDrawer.closest('dialog');
        }
      }
      
      return drawer;
    };
    
    const updateButtonText = (isOpen) => {
      if (!toggleLabel || !toggleButton) return;
      
      const showText = toggleButton.dataset.showFiltersText || 'Filter';
      const hideText = toggleButton.dataset.hideFiltersText || 'Hide filters';
      
      toggleLabel.textContent = isOpen ? hideText : showText;
    };
    
    let drawer = findFiltersDrawer();
    
    // If drawer not found, wait a bit for it to be loaded
    if (!drawer) {
      // Try again after a short delay in case it loads dynamically
      setTimeout(() => {
        drawer = findFiltersDrawer();
        if (drawer) {
          initializeDrawerObserver(drawer);
        }
      }, 100);
      return;
    }
    
    initializeDrawerObserver(drawer);
    
    function initializeDrawerObserver(drawer) {
    
      // Get the actual dialog element if drawer is a component
      const dialogElement = drawer.querySelector?.('dialog[ref="dialog"]') || 
                            drawer.tagName === 'DIALOG' ? drawer : 
                            drawer.querySelector?.('dialog');
      
      // Check initial state
      if (dialogElement) {
        updateButtonText(dialogElement.open);
      }
      
      // Listen for dialog open/close events
      const handleDialogOpen = () => updateButtonText(true);
      const handleDialogClose = () => updateButtonText(false);
      
      drawer.addEventListener('dialog:open', handleDialogOpen);
      drawer.addEventListener('dialog:close', handleDialogClose);
      
      // Also observe the dialog element's open attribute/state if available
      if (dialogElement) {
        const observer = new MutationObserver(() => {
          updateButtonText(dialogElement.open);
        });
        
        observer.observe(dialogElement, {
          attributes: true,
          attributeFilter: ['open']
        });
        
        // Also check on click in case the state changes before events fire
        toggleButton.addEventListener('click', () => {
          setTimeout(() => {
            if (dialogElement) {
              updateButtonText(dialogElement.open);
            }
          }, 0);
        });
      }
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["load-more-button"] && !Shopify.designMode) return;
  try {
    class LoadMoreButton {
      constructor(button) {
        this.button = button;
        this.sectionId = button.dataset.sectionId;
        // Ensure currentPage defaults to 1 if 0 or invalid
        const currentPageValue = parseInt(button.dataset.currentPage);
        this.currentPage = (currentPageValue && currentPageValue > 0) ? currentPageValue : 1;
        this.lastPage = parseInt(button.dataset.lastPage) || 1;
        this.currentProducts = parseInt(button.dataset.currentProducts) || 0;
        this.totalProducts = parseInt(button.dataset.totalProducts) || 0;
        this.productsPerPage = parseInt(button.dataset.productsPerPage) || 24;
        this.grid = null;
        this.isLoading = false;
        
        // Recalculate currentProducts if it's 0 but we're on page 1+
        if (this.currentProducts === 0 && this.currentPage >= 1) {
          this.currentProducts = Math.min(this.currentPage * this.productsPerPage, this.totalProducts);
        }
        
        this.#findGrid();
        this.#attachEventListeners();
        this.#updateButtonText();
      }
      
      #findGrid() {
        // Find the product grid element
        const resultsList = this.button.closest('results-list');
        if (resultsList) {
          const grid = resultsList.querySelector('[ref="grid"]');
          if (grid) {
            this.grid = grid;
          }
        }
      }
      
      #attachEventListeners() {
        this.button.addEventListener('click', () => this.#handleClick());
      }
      
      async #handleClick() {
        if (this.isLoading) return;
        if (this.currentPage >= this.lastPage) return;
        
        this.isLoading = true;
        this.#setLoadingState(true);
        
        try {
          const nextPage = this.currentPage + 1;
          const nextPageUrl = new URL(window.location.href);
          nextPageUrl.searchParams.set('page', nextPage.toString());
          nextPageUrl.searchParams.set('section_id', this.sectionId);
          nextPageUrl.hash = '';
          nextPageUrl.searchParams.sort();
          
          // Fetch the next page HTML using Section Rendering API
          const response = await fetch(nextPageUrl.toString());
          if (!response.ok) {
            throw new Error(`Failed to fetch: ${response.statusText}`);
          }
          const pageHTML = await response.text();
          
          if (!pageHTML) {
            throw new Error('Failed to fetch next page');
          }
          
          // Parse the HTML and extract product cards
          const parser = new DOMParser();
          const doc = parser.parseFromString(pageHTML, 'text/html');
          const nextPageGrid = doc.querySelector('[ref="grid"]');
          
          if (!nextPageGrid || !this.grid) {
            throw new Error('Failed to find grid elements');
          }
          
          const cards = nextPageGrid.querySelectorAll(':scope > [ref="cards[]"]');
          
          if (cards.length === 0) {
            throw new Error('No products found on next page');
          }
          
          // Update data-last-page if it changed
          const newLastPage = nextPageGrid.dataset.lastPage;
          if (newLastPage) {
            this.grid.dataset.lastPage = newLastPage;
            this.lastPage = parseInt(newLastPage);
          }
          
          // Append cards to the grid
          cards.forEach(card => {
            this.grid.appendChild(card);
          });
          
          // Update current page and product counts
          this.currentPage = nextPage;
          // Calculate products shown based on page number
          this.currentProducts = Math.min(this.currentPage * this.productsPerPage, this.totalProducts);
          this.button.dataset.currentPage = nextPage.toString();
          this.button.dataset.currentProducts = this.currentProducts.toString();
          
          // Update URL without reload
          history.pushState('', '', nextPageUrl.toString());
          
          // Update button text with new counts
          this.#updateButtonText();
          
          // Hide button if we've reached the last page
          if (this.currentPage >= this.lastPage) {
            this.button.hidden = true;
          }
          
          // Trigger events that might be needed for aspect ratio helpers or other components
          const event = new CustomEvent('load-more:loaded', {
            detail: { page: nextPage, cards: Array.from(cards) },
            bubbles: true
          });
          this.grid.dispatchEvent(event);
          
        } catch (error) {
          console.error('Error loading more products:', error);
          this.#showError();
        } finally {
          this.isLoading = false;
          this.#setLoadingState(false);
        }
      }
      
      #updateButtonText() {
        const countText = `(${this.currentProducts} / ${this.totalProducts})`;
        const text = this.button.querySelector('.load-more-button__text');
        const loadingEl = this.button.querySelector('.load-more-button__loading');
        const textCount = text?.querySelector('.load-more-button__count');
        const loadingCount = loadingEl?.querySelector('.load-more-button__count');
        
        if (textCount) {
          textCount.textContent = countText;
        }
        if (loadingCount) {
          loadingCount.textContent = countText;
        }
      }
      
      #setLoadingState(loading) {
        const text = this.button.querySelector('.load-more-button__text');
        const loadingEl = this.button.querySelector('.load-more-button__loading');
        
        if (loading) {
          if (text) text.hidden = true;
          if (loadingEl) loadingEl.hidden = false;
          this.button.disabled = true;
        } else {
          if (text) text.hidden = false;
          if (loadingEl) loadingEl.hidden = true;
          this.button.disabled = false;
        }
      }
      
      #showError() {
        const text = this.button.querySelector('.load-more-button__text');
        if (text) {
          text.textContent = 'Error loading products. Please try again.';
        }
      }
    }
    
    // Initialize all load more buttons
    document.addEventListener('DOMContentLoaded', () => {
      const buttons = document.querySelectorAll('.load-more-button');
      buttons.forEach(button => {
        new LoadMoreButton(button);
      });
    });
    
    // Also handle dynamically added buttons
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) { // Element node
            const buttons = node.querySelectorAll?.('.load-more-button') || [];
            buttons.forEach(button => {
              if (!button.dataset.loadMoreInitialized) {
                button.dataset.loadMoreInitialized = 'true';
                new LoadMoreButton(button);
              }
            });
            
            if (node.classList?.contains('load-more-button') && !node.dataset.loadMoreInitialized) {
              node.dataset.loadMoreInitialized = 'true';
              new LoadMoreButton(node);
            }
          }
        });
      });
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-grid"] && !Shopify.designMode) return;
  try {
    class FilterPanel {
    constructor() {
      this.toggleButton = document.querySelector('[data-filter-toggle]');
      this.filterPanel = document.querySelector('[data-filter-panel]');
      this.collectionWrapper = document.querySelector('.collection-wrapper');
      this.overlay = document.querySelector('.filters-mobile__overlay');
      
      if (!this.filterPanel || !this.collectionWrapper) return;
      
      this.isOpen = false;
      
      if (this.toggleButton) {
        this.toggleButton.addEventListener('click', () => {
          this.toggle();
        });
      }
      
      // Delegated: facets.js replaces the panel's innerHTML after every filter
      // change, which would drop a listener bound to the "See items" button.
      this.filterPanel.addEventListener('click', (e) => {
        if (e.target.closest('[data-filter-close]')) {
          this.close();
        }
      });
      
      // Close on overlay click (mobile)
      if (this.overlay) {
        this.overlay.addEventListener('click', () => {
          if (this.isOpen) {
            this.close();
          }
        });
      }
      
      // Close on escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen) {
          this.close();
        }
      });
    }
    
    toggle() {
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    }
    
    open() {
      this.isOpen = true;
      this.filterPanel.setAttribute('data-filter-open', 'true');
      this.collectionWrapper.setAttribute('data-filters-open', 'true');
      if (this.toggleButton) {
        this.toggleButton.setAttribute('aria-expanded', 'true');
        this.updateButtonText(true);
      }
      // Close sorting panel if open
      if (window.sortingPanel && window.sortingPanel.isOpen) {
        window.sortingPanel.close();
      }
    }
    
    close() {
      this.isOpen = false;
      this.filterPanel.setAttribute('data-filter-open', 'false');
      this.collectionWrapper.setAttribute('data-filters-open', 'false');
      if (this.toggleButton) {
        this.toggleButton.setAttribute('aria-expanded', 'false');
        this.updateButtonText(false);
      }
    }
    
    updateButtonText(isOpen) {
      const label = this.toggleButton?.querySelector('[data-filter-toggle-label]');
      if (!label) return;
      
      const showText = this.toggleButton.dataset.showFiltersText || 'Filter';
      const hideText = this.toggleButton.dataset.hideFiltersText || 'Hide filters';
      
      label.textContent = isOpen ? hideText : showText;
    }
  }
  
  class SortingPanel {
    constructor() {
      this.toggleButton = document.querySelector('[data-sort-toggle]');
      this.sortPanel = document.querySelector('[data-sort-panel]');
      this.collectionWrapper = document.querySelector('.collection-wrapper');
      this.overlay = document.querySelector('.filters-mobile__overlay');
      
      if (!this.toggleButton || !this.sortPanel) {
        console.warn('SortingPanel: Missing required elements', { toggleButton: !!this.toggleButton, sortPanel: !!this.sortPanel });
        return;
      }
      
      this.isOpen = false;
      
      this.toggleButton.addEventListener('click', () => {
        this.toggle();
      });
      
      // Close on overlay click (mobile)
      if (this.overlay) {
        this.overlay.addEventListener('click', () => {
          if (this.isOpen) {
            this.close();
          }
        });
      }
      
      // Close on escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen) {
          this.close();
        }
      });
    }
    
    toggle() {
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    }
    
    open() {
      if (!this.sortPanel) return;
      this.isOpen = true;
      this.sortPanel.setAttribute('data-sort-open', 'true');
      if (this.collectionWrapper) {
        this.collectionWrapper.setAttribute('data-sort-open', 'true');
      }
      if (this.toggleButton) {
        this.toggleButton.setAttribute('aria-expanded', 'true');
        this.updateButtonText(true);
      }
      // Close filter panel if open
      if (window.filterPanel && window.filterPanel.isOpen) {
        window.filterPanel.close();
      }
    }
    
    close() {
      if (!this.sortPanel) return;
      this.isOpen = false;
      this.sortPanel.setAttribute('data-sort-open', 'false');
      if (this.collectionWrapper) {
        this.collectionWrapper.setAttribute('data-sort-open', 'false');
      }
      if (this.toggleButton) {
        this.toggleButton.setAttribute('aria-expanded', 'false');
        this.updateButtonText(false);
      }
    }
    
    updateButtonText(isOpen) {
      const label = this.toggleButton?.querySelector('[data-sort-toggle-label]');
      if (!label) return;
      
      const showText = this.toggleButton.dataset.showSortText || 'Sort';
      const hideText = this.toggleButton.dataset.hideSortText || 'Close';
      
      label.textContent = isOpen ? hideText : showText;
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.filterPanel = new FilterPanel();
      window.sortingPanel = new SortingPanel();
    });
  } else {
    window.filterPanel = new FilterPanel();
    window.sortingPanel = new SortingPanel();
  }
  } catch(e) { console.error(e); }
})();

})();
